<template>
    <client-page>
        <sub-visual sh="Alliance" bg="/images/sub/visual/sv4.jpg"> </sub-visual>

        <section class="section section--first pb-0">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">
                        Alliance
                    </h2>
                </div>

                <div v-scroll="onScrollFixed" class="scroll-fixed-tab w-100">
                    <scrollactive :offset="$vuetify.breakpoint.lgAndUp ? 177 : 102" :scrollOffset="$vuetify.breakpoint.lgAndUp ? 177 : 102" :highlightFirstItem="true" active-class="v-tab--active" class="my-nav v-tabs v-tab--primary">
                        <router-link to="#abb" class="scrollactive-item v-tab">ABB</router-link>
                        <router-link to="#teledyne" class="scrollactive-item v-tab">TELEDYNE</router-link>
                        <router-link to="#pac" class="scrollactive-item v-tab">PAC</router-link>
                        <router-link to="#metal" class="scrollactive-item v-tab">METAL SAMPLES</router-link>
                        <router-link to="#extrel" class="scrollactive-item v-tab">EXTREL</router-link>
                    </scrollactive>
                </div>
            </v-container>
        </section>

        <section id="abb" class="section pt-0">
            <v-container>
                <top-image tit="ABB" bgImage="/images/sub/alliance/abb-bg.jpg" image="/images/sub/alliance/abb-img.jpg">
                    <p class="page-text mb-6 mb-lg-20">
                        분석 측정 기술을 이용하여 모든 문제를 해결할 수 있는<br class="d-none d-lg-block" />
                        1,000여개의 솔루션을 손쉽게 구축할 수 있습니다.
                    </p>
                    <p class="page-text">솔루션 및 일괄 공급이 가능한 공급업체로써 <br class="d-none d-lg-block" />케이아이이 시스템즈의 신뢰할 수 있는 파트너입니다.</p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://global.abb/group/en" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>

        <section id="teledyne" class="section pt-0">
            <v-container>
                <top-image tit="TELEDYNE" bgImage="/images/sub/alliance/teledyne-bg.jpg" image="/images/sub/alliance/teledyne-img.jpg">
                    <p class="page-text">Teledyne은 산업 성장 시장을 위한 정보를 감지, 전송 및 분석할 수 있는 지원 기술을 제공합니다. 이러한 시장에는 항공 우주 및 방위, 공장 자동화, 대기 및 수질 환경 모니터링, 전자 설계 및 개발, 해양 연구, 에너지, 의료 영상 및 제약 연구 등이 포함됩니다.</p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://www.teledyne-ai.com/" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>

        <section id="pac" class="section pt-0">
            <v-container>
                <top-image tit="PAC" bgImage="/images/sub/alliance/pac-bg.jpg" image="/images/sub/alliance/pac-img.jpg">
                    <p class="page-text">PAC는 석유화학, 정유, 업스트림, 바이오 연료, 환경, 식품 및 음료, 윤활제, 자동차 및 제약과 같은 산업에서 실험실 및 온라인 프로세스 응용을 위한 고급 분석 기기의 선도적인 글로벌 제조업체입니다.</p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://www.paclp.com/" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>

        <section id="metal" class="section section--last pt-0">
            <v-container>
                <top-image tit="Metal Samples" bgImage="/images/sub/alliance/metal-bg.jpg" image="/images/sub/alliance/metal-img.jpg">
                    <p class="page-text">Metal Samples는 부식 모니터링 및 재료 평가를 위한 제품을 전문적으로 제조하며, 1980년 이래로 전 세계의 화학 처리, 수처리 및 석유 산업에 제품과 서비스를 공급해 왔습니다.</p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://www.alspi.com/" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>

        <section id="extrel" class="section section--last pt-0">
            <v-container>
                <top-image tit="EXTREL" bgImage="/images/sub/alliance/extrel-bg.jpg" image="/images/sub/alliance/extrel-img.jpg">
                    <p class="page-text mb-6 mb-lg-20">Extrel 공정 질량 분석기는 Hydrocarbon 공정, Syngas 제조, 금속 제조, Gas Purity 등과 같은 분야에서 높은 신뢰성과 편의성을 제공합니다. 이 분석기는 전 세계 수천 개의 제조 시설에서 사용되고 있으며, 40년 이상의 산업 자동화 분야에서의 노하우를 쌓아온 전문가들이 설계하였습니다.</p>
                    <div class="mt-30 mt-md-60 mt-lg-80">
                        <v-btn outlined tile width="180" color="primary" href="https://www.extrel.com/" target="_blank" class="justify-space-between"> <span>Web site</span><v-icon size="16">mdi-open-in-new</v-icon> </v-btn>
                    </div>
                </top-image>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import TopImage from "@/components/dumb/top-image.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        TopImage,
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.lastTabActive();
            });
        },
        onScrollFixed: function() {
            let scrollPosition = 0,
                mobileWidth = 1200;

            let tabsWrap = document.querySelector(".scroll-fixed-tab"),
                tabs = document.querySelector(".scroll-fixed-tab .v-tabs"),
                absoluteTop = 0,
                headerHeight = 60,
                tabHeight = 42;
            if (window.innerWidth > mobileWidth) {
                headerHeight = 115;
                tabHeight = 62;
            }

            scrollPosition = window.scrollY || window.pageYOffset;
            absoluteTop = window.pageYOffset + tabsWrap.getBoundingClientRect().top - headerHeight;

            if (scrollPosition < absoluteTop) {
                tabs.classList.remove("active");
            } else {
                tabs.classList.add("active");
            }
        },
        lastTabActive: function() {
            let scrollPosition = 0,
                ticking = false,
                mobileWidth = 1200;
            let timeout;

            let BODY = document.querySelector("body"),
                tab = document.querySelectorAll(".scroll-fixed-tab .v-tab"),
                innerHeight = window.innerHeight,
                headerHeight = 50,
                tabHeight = 50,
                scrollHeight = BODY.scrollHeight;
            if (window.innerWidth > mobileWidth) {
                tabHeight = 60;
            }

            function animate() {
                scrollPosition = window.scrollY || window.pageYOffset;

                // for (let i = 0; i < tab.length; i++) {
                //     let last = tab.length;

                //     if (scrollPosition + innerHeight >= scrollHeight) {
                //         tab[i].classList.remove("v-tab--active");
                //         tab[last].classList.add("v-tab--active");
                //     } else {
                //         tab[last].classList.remove("v-tab--active");
                //     }
                // }

                // tab.forEach(function(item, index) {
                //     if (scrollPosition + innerHeight >= scrollHeight) {
                //         console.log(item);
                //         if (index == item.length) {
                //             item.classList.add("v-tab--active");
                //         } else {
                //             item.classList.remove("v-tab--active");
                //         }
                //     }else{
                //         if (index == item.length) {
                //             item.classList.remove("v-tab--active");
                //         }
                //     }
                // });
            }
            animate();

            window.addEventListener("scroll", function(e) {
                if (!ticking) {
                    window.requestAnimationFrame(function() {
                        animate();
                        ticking = false;
                    });
                    ticking = true;
                }
            });
            window.addEventListener("resize", resize, false);
            function resize() {
                if (!timeout) {
                    timeout = setTimeout(function() {
                        timeout = null;
                        handle();
                    }, 66);
                }
            }
            function handle() {
                let windowWidth = window.outerWidth;
                if (windowWidth > mobileWidth) {
                    animate();
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.scroll-fixed-tab {
    --tab-height: 42px;
    height: var(--tab-height);
    margin-bottom: 60px;
    transition: 0.25s ease-out;
    .active {
        position: fixed;
        top: var(--header-body);
        left: 0;
        width: 100vw;
        z-index: 99;
        &.v-tab--primary {
            background-color: #fff;
            margin-bottom: 0 !important;
        }
    }
    .my-nav {
        display: flex;
        height: var(--tab-height);
        .scrollactive-item.v-tab {
            width: 25% !important;
        }
    }
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .scroll-fixed-tab {
        margin-bottom: 90px;
    }
}
@media (min-width: 1200px) {
    .scroll-fixed-tab {
        --tab-height: 62px;
    }
}
</style>
